import { useNavigate } from '@rocketlane/rocket-router';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { NITRO_CLAW_AGENT_NAME } from 'api/nitro-claw';
import { prependAgentConversationToHistory } from 'queries/ai-chat/ai-chat';
import { ROUTE_PATHS } from 'routes/routes-paths';
import { isQuickEntryWindow } from 'utils/desktop-window';
import { isTauriApp } from 'utils/is-tauri';
import { focusMainWindow, listenQuickEntryActions } from 'utils/quick-entry-native';
const ROUTE_BASE = `/${ROUTE_PATHS.NITRO_CLAW}`;
/**
 * Main-window bridge: Quick Entry overlay emits actions; this navigates Nitro Claw.
 */ export const useQuickEntryBridge = ()=>{
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    useEffect(()=>{
        if (!isTauriApp() || isQuickEntryWindow()) {
            return undefined;
        }
        let unlisten;
        let cancelled = false;
        const handle = async (action)=>{
            await focusMainWindow();
            if (action.type === 'submit') {
                const conversationId = action.conversationId || uuidv4();
                prependAgentConversationToHistory(queryClient, NITRO_CLAW_AGENT_NAME, {
                    conversation_id: conversationId,
                    title: action.message.trim().slice(0, 80) || undefined
                });
                navigate(`${ROUTE_BASE}/${conversationId}`, {
                    state: {
                        initialMessage: action.message
                    }
                });
                return;
            }
            if (action.type === 'open') {
                navigate(`${ROUTE_BASE}/${action.conversationId}`);
                return;
            }
            navigate(ROUTE_BASE);
        };
        listenQuickEntryActions(handle).then((fn)=>{
            if (cancelled) {
                fn();
                return;
            }
            unlisten = fn;
        });
        return ()=>{
            cancelled = true;
            unlisten === null || unlisten === void 0 ? void 0 : unlisten();
        };
    }, [
        navigate,
        queryClient
    ]);
};
